import { render, staticRenderFns } from "./DangerModal.vue?vue&type=template&id=2c3be1a6&"
import script from "./DangerModal.vue?vue&type=script&lang=js&"
export * from "./DangerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports